export default __webpack_public_path__ + "static/media/threebtm.3c011595.png";